// extracted by mini-css-extract-plugin
module.exports = {"home":"styles_home__jLAFo","gradient":"styles_gradient__N0X3z"};